module.exports = __webpack_public_path__ + "static/media/forklift.aa274f4d.png";